export default __webpack_public_path__ + "static/media/lubaantunGrid1.200541c6.webp";